const getState = state => state.playground

export const allBookingsSelector = state => getState(state).bookings
export const isCompleteSelector = state => getState(state).isComplete



// WEBPACK FOOTER //
// ./src/reduxModules/selectors/PlaygroundSelectors.js